import React, { useEffect } from 'react'
import NewHeader from '../components/layout/NewHeader'
import Modal from '../components/layout/modal'
import { GameTrivia } from '../components/triviaAmerica/gameTrivia'
import FinishTrivia from '../components/triviaAmerica/finishTrivia'

//HOOKS
import { useTriviaAmerica } from '../hooks/useTriviaAmerica'

const Trivia = () => {
    const questions = useTriviaAmerica(state => state.trivia.questions)
    const isResult = useTriviaAmerica(state => state.isResult)
    const result = useTriviaAmerica(state => state.result)
    const fetchQuestions = useTriviaAmerica(state => state.fetchQuestions)

    // fetchQuestions()
    
    useEffect(() => {
        if (questions.length <= 0) {
            fetchQuestions()
        }
    }, [])
    
    return (
        <>
            <NewHeader />
            <Modal />

            <div className="lottery-trivia">
                <h1 className='lottery-trivia_hidden'>TRIVIA DE FÚTBOL</h1>
                <div className="lottery-trivia_scroll">
                    <div className="lottery-trivia_container">
                        {questions.length <= 0 
                            ? <span></span>
                            : isResult
                                ? <FinishTrivia result={result} />
                                : <GameTrivia />
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default Trivia